import React, {useState} from 'react';

import {Tab} from "./types/tab.interface.ts";
import styles from './Tabs.module.css';
import {cn} from "../../../utils/cn.ts";


interface Props {
    tabs: Tab[];
}

export const Tabs: React.FC<Props> = ({tabs}) => {
    const url = new URL(window?.location.href || '');
    const tabParams = url.searchParams.get('tab');
    const [activeIndex, setActiveIndex] = useState(tabParams ? Number(tabParams) : 0);

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                {tabs.map(({label}, index) => (
                    <h2
                        key={index}
                        onClick={() => setActiveIndex(index)}
                        className={cn(
                            styles.tabLabel,
                            index === activeIndex ? styles.tabLabelActive : '',
                        )}
                    >
                        {label}
                    </h2>
                ))}
            </div>
            <div className={styles.tabContent}>{tabs[activeIndex].content}</div>
        </div>
    );
};